import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, "質問コンバーターを設定", -1)
const _hoisted_3 = {
  key: 0,
  class: "fl mr15"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fs24 fl mr10 ml10 mt20" }, "⇒", -1)
const _hoisted_6 = {
  class: "fl",
  style: {"max-width":"240px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  class: "centered",
  style: {"margin-top":"50px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "質問コンバーターが見つかりませんでした。", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "padw10 fl" }
const _hoisted_17 = {
  class: /*#__PURE__*/_normalizeClass(`fs14 fw600 `)
}
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 2,
  style: {"margin-top":"50px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_MdTextfieldTag, {
            name: "waaqではないフォームの質問の外部name",
            placeholder: "外部nameを入力してください。",
            style: {"height":"56px","min-width":"240px","max-width":"240px"},
            class: "fl fs14",
            value: _ctx.newconv.ext_name,
            onInputValue: _ctx.inputConvExtName
          }, null, 8, ["value", "onInputValue"]),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SelectTag, {
              class: "fl fs14 roundForm",
              style: {"min-width":"30px","height":"50px"},
              options: (_ctx.fcm?.fields ? _ctx.fcm.fields : _ctx.rcm?.fields || []).map(f => f.field_name),
              optionName: `form_field_name`,
              defaultOption: _ctx.newconv.form_field_name,
              needUnselect: true,
              onSelectValue: _ctx.selectFormFieldName
            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
            _hoisted_7
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "fl pointer centered circle_button skyblueBg fs14 rad8 ml20 mt15 padw10",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveConv && _ctx.saveConv(...args)))
          }, " 追加 ")
        ]))
      : _createCommentVNode("", true),
    _hoisted_8,
    (_ctx.convs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.convs.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                    width: "40",
                    height: "40"
                  }, null, 8, _hoisted_13)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.convs)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.convs, (conv, convindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: convindex,
                        class: "borderGrey rad4"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/box_two.png`),
                            height: "22",
                            width: "22",
                            class: "fl mt10 ml10"
                          }, null, 8, _hoisted_15),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(conv.ext_name) + " ⇒ " + _toDisplayString(conv.form_field_name), 1)
                          ]),
                          (_ctx.canEdit)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                width: "20",
                                height: "23",
                                class: "pointer fr mr15 mt10",
                                onClick: ($event: any) => (_ctx.removeConv(conv))
                              }, null, 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          _hoisted_19
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                _hoisted_20
              ]))
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_21, [
          _createVNode(_component_RoomsLoader)
        ]))
  ]))
}